<template>
  <div>
    <TituloPagina :titulo="tituloDaPagina" />

    <v-card
      class="gradiente-card mt-5 shaped rounded-corner pt-5 mx-auto"
      dark
      height="168"
      width="296"
    >
      <v-sheet
        class="border-radius-0"
        height="30"
        tile
        color="black"
      />
      <v-sheet
        class="border-radius-0 mt-4 mx-3 text-right pr-5 pt-1"
        style="position: relative;"
        height="30"
        tile
        color="white"
        light
      >
        {{ security_token || maskCvc }}
        <v-btn
          absolute
          fab
          outlined
          right
          bottom
          color="red darken-1"
          :class="'circleCVV'"
          data-cy="circulo_destaque_cvv"
        />
      </v-sheet>
    </v-card>

    <p
      class="pa-0 mt-4 mb-6 primary--text"
      data-cy="texto_da_pagina"
    >
      Informe o código de confirmação que consta no verso do seu cartão.
    </p>

    <v-form>
      <v-col class="col-12 py-0 pl-0 pr-0 mt-6 mb-0 mb-md-5">
        <v-text-field
          v-model="security_token"
          v-mask="'####'"
          :error-messages="errorMessageCodigo"
          maxlength="4"
          filled
          background-color="white"
          label="Código de segurança (CVV)"
          data-cy="codigo_de_seguranca"
          @blur="$v.security_token.$touch()"
        />
      </v-col>
    </v-form>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { required, minLength } from 'vuelidate/lib/validators';

import TituloPagina from '@/components/TituloPagina.vue';

export default {
  name: 'PassoCodigoConfirmacao',

  components: {
    TituloPagina,
  },

  directives: { mask },

  data() {
    return {
      tituloDaPagina: 'Código de confirmação',
      maskCvc: '000',
      security_token: '',
      messages: {
        required: 'Esse campo é obrigatório.',
        counter: 'Mínimo de 3 caracteres',
      },
    };
  },

  computed: {
    errorMessageCodigo() {
      if (!this.$v.security_token.minLength
        && this.$v.security_token.$dirty) return this.messages.counter;
      if (!this.$v.security_token.required
        && this.$v.security_token.$dirty) return this.messages.required;
      return [];
    },
  },

  watch: {
    security_token() {
      this.enviarCodigoCVV();
    },
  },

  methods: {
    enviarCodigoCVV() {
      const valido = !this.$v.security_token.$invalid;
      const dados = valido ? this.security_token : '';

      this.$emit('formValidado', {
        form: { security_token: dados },
        validado: valido,
      });
    },
  },

  validations: {
    security_token: {
      required,
      minLength: minLength(3),
    },
  },


};
</script>

<style lang="scss">
  .border-radius-0{
  border-radius: 0!important
}
.circleCVV{
  right: 7px!important;
  bottom:-13px!important;
}
</style>
